import { usePage } from "@inertiajs/react";
import { DefaultPageType } from "types/DefaultPageType";

const tagPathRegex = new RegExp(/\/browse\/tags\/.*\/.*/);
const userPathRegex = new RegExp(/\/@.*/);

export default function useTransparentNav() {
  const { pathName } = usePage<DefaultPageType>().props;

  if (pathName.startsWith("/books")) {
    return true;
  }

  return userPathRegex.test(pathName) || tagPathRegex.test(pathName);
}
